// Felles for «Tjenester og priser» (planer/hygraph-plan.md): kall til /tjenestekatalog og
// visningsnavn for valgene i katalogen.
import { useCallback, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { glemKatalog } from '../../lib/tjenestekatalogApi';

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/+$/, '');

export const KATEGORI_NAVN = { sykkelservice: 'Sykkel', skiservice: 'Ski', skoyteslip: 'Skøyter', tekstiltrykk: 'Trykk' };

export const BOOKING_NAVN = {
  dag: 'Dagservice',
  uke: 'Ukeservice',
  tidliguke: 'Tidlig i uken',
  senuke: 'Sent i uken',
  dropIn: 'Drop-in',
};

export const SERVICETYPE_NAVN = {
  servicepakker: 'Servicepakker', bremseservice: 'Bremseservice', girservice: 'Girservice',
  etterkontroll: 'Etterkontroll', garanti: 'Garanti', dekkSlangeskift: 'Dekk-/slangeskift',
  hjulNav: 'Hjul og nav', annet: 'Annet', bytteKomponenter: 'Bytte komponenter',
  preparering: 'Preparering', steinslip: 'Steinslip', slipAvStalkanter: 'Slip av stålkanter',
  monteringAvBindinger: 'Montering av bindinger', motorservice: 'Motorservice', software: 'Programvare',
  slipAvSkoyter: 'Slip av skøyter',
};

export const SYKKELTYPE_NAVN = {
  sykkelUtenMotor: 'Sykkel uten motor', sykkelMedMotor: 'Elsykkel', lastesykkelTandem: 'Lastesykkel/tandem',
  alleSykkeltyper: 'Alle sykkeltyper', langrennski: 'Langrennski', alpinski: 'Alpinski',
  randonneski: 'Randonnéski', snobrett: 'Snøbrett', skistaver: 'Skistaver', alleSkityper: 'Alle skityper',
};

export const LOKASJON_NAVN = {
  roykenSykkelverksted: 'Røyken Sykkelverksted',
  sport1Royken: 'Sport 1 Røyken',
  sport1Slemmestad: 'Sport 1 Slemmestad',
};

export const DAG_NAVN = {
  mandag: 'Man', tirsdag: 'Tir', onsdag: 'Ons', torsdag: 'Tor', fredag: 'Fre', lordag: 'Lør', sondag: 'Søn',
};

export const kr = (n) => (typeof n === 'number' ? `${n.toLocaleString('nb-NO')} kr` : '–');
export const min = (n) => (typeof n === 'number' ? `${n} min` : '–');

// Lagrer i katalogen. Navnet på den valgte ansatte sendes med, så backenden kan sjekke at det er
// leder eller mekaniker og skrive navnet i endringsloggen.
async function kallKatalog(metode, sti, body, headers = {}) {
  const res = await fetch(`${API_BASE_URL}/tjenestekatalog/${sti}`, {
    method: metode,
    headers: { ...headers, 'X-Ansatt': encodeURIComponent(Cookies.get('selectedEmployee') || '') },
    body,
  });
  const svar = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(svar.message || 'Klarte ikke å lagre. Prøv igjen.');
  glemKatalog();
  return svar;
}

export function lagreIKatalog(metode, sti, data) {
  return kallKatalog(metode, sti, data ? JSON.stringify(data) : undefined, { 'Content-Type': 'application/json' });
}

// Bilder på en tjeneste lagres med en gang, uavhengig av skjemaet.
export function lastOppBilde(tjenesteId, fil) {
  const skjema = new FormData();
  skjema.append('bilde', fil);
  return kallKatalog('POST', `tjenester/${tjenesteId}/bilder`, skjema);
}

export function fjernBilde(tjenesteId, url) {
  return kallKatalog('DELETE', `tjenester/${tjenesteId}/bilder?url=${encodeURIComponent(url)}`);
}

// Hele katalogen for redigering (GET /tjenestekatalog/admin), med en funksjon for å hente på nytt.
export function useKatalogAdmin() {
  const [data, setData] = useState(null);
  const [feil, setFeil] = useState('');
  const hent = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/tjenestekatalog/admin`);
      if (!res.ok) throw new Error();
      setData(await res.json());
      setFeil('');
    } catch {
      setFeil('Klarte ikke å hente tjenestekatalogen. Last siden på nytt om litt.');
    }
  }, []);
  useEffect(() => { hent(); }, [hent]);
  return { data, feil, hent };
}

// Bare feltene som er endret i skjemaet, så endringsloggen ikke fylles med «tomt → false» for
// felt ingen har rørt.
export function endredeFelt(skjema, original) {
  return Object.fromEntries(Object.entries(skjema).filter(([f, v]) => JSON.stringify(v) !== JSON.stringify(original[f])));
}

// «Endret 28.10 av Test Leder»: siste rad i endringsloggen.
export function sistEndret(post) {
  const siste = (post?.endringer || []).at(-1);
  if (!siste?.dato) return '';
  const dato = new Date(siste.dato).toLocaleDateString('nb-NO', { day: 'numeric', month: 'numeric', year: '2-digit' });
  return siste.utfortAv ? `Sist endret ${dato} av ${siste.utfortAv}` : `Sist endret ${dato}`;
}
